import { getAccountLiabIndex } from 'components/liability/common'
/**
 * 格式——万元
 * @param  {Number} number
 * @return {Number}
 */
export const formatTenThousand = number => {
  var regExp = /^[+-]?[1-9]?[0-9]*\.[0-9]*$/
  var result = 0
  if (isNaN(number * 1)) return number
  number = parseFloat(number)
  if (number % 10000 === 0 && number >= 10000) {
    number = number / 10000
    result = (regExp.test(number) ? number.toFixed(2) : number) + '万'
  } else {
    result = regExp.test(number) ? number.toFixed(2) : number
  }
  return result
}

/**
 * 格式化asc2 空格 换行
 * @param  {String} str [字符串]
 * @return {String}     [字符串]
 */
export const formatASCII = str => {
  return str
    .replace(/ +/g, '')
    .replace(/[ ]/g, '')
    .replace(/[\r\n]/g, '')
}

export function formatDisplayData (data) {
  const regUnit = /元/
  const regAmount = /(\d+\.\d+|\d+)元/
  const regAmounts = /(\d+\.\d+|\d+)元/g
  let resultTemp = data[0]
  for (var i = 1; i < arguments.length; i++) {
    const theData = data[i]
    let arg = String(arguments[i])
    // 金额显示整万
    if (theData.match(regUnit)) {
      arg = String(formatTenThousand(arg))
    } else if (arg.match(regUnit)) {
      // 针对三元运算符内整万显示
      // 正则匹配
      // 同一条责任多个数据转换
      const matchMoney = arg.match(regAmounts)
      if (matchMoney) {
        if (matchMoney.length > 1 && matchMoney[1]) {
          arg = arg.replace(regAmounts, function () {
            // arguments 对应各个匹配的字符
            return `${String(
              formatTenThousand(arguments[0].match(regAmount)[1])
            )}元`
          })
        } else {
          const matchNum = matchMoney[0] || matchMoney
          arg = arg.replace(regAmounts, function () {
            // matchMoney = arguments[0]元
            return `${String(
              formatTenThousand(matchNum.match(/(\d+\.\d+|\d+)元/)[1])
            )}元`
          })
        }
      }
    }

    // 金额显示保留2位小数
    // fix 纯数字才进入逻辑
    if (!isNaN(arg) && arg.split('.')[1]) {
      arg = arg.split('.')[1].length > 2 ? parseFloat(arg).toFixed(2) : arg
    }
    resultTemp += arg + theData
  }
  return resultTemp
}

/**
 * 追加领取责任
 * @param  {String} type   [add|take]
 * @param  {Array}  infor  [当年信息]
 * @param  {Number} insuredAge [投保年龄]
 * @return {String}        [责任描述]
 */
export const formatAddAndTakeText = (type, infor, insuredAge) => {
  const hand = type === 'add' ? '交' : '领'
  const start = infor[0]
  const end = infor[1]
  const money = infor[2]
  const use = infor[3]
  const age = insuredAge + start
  if (start === end) {
    let text = `${age}岁${hand}<span>${money}</span>元`
    if (use) text = `${text}, ${use}`
    return text
  } else if (start < end) {
    let text = `${age}岁—${insuredAge +
      end}岁每年${hand}<span>${money}</span>元`
    if (use) text = `${text}, ${use}`
    return text
  }
}

/**
 * 格式化计算数据
 * @param  {Object} originalData [原始数据]
 * @return {Object}              [格式化数据key]
 */
export const formatCalculateData = (originalData, normalizeKeys) => {
  let calData = {} // 计算数据
  let personData = {} // 人员数据
  let tableData = [] // 表格数据
  let accountsData = [] // 追加领取
  let accountMap = {} // -
  let termsData = [] // 条款数据
  let productNameList = {} // 产品名称
  let productCommonData = {} // 产品通用信息
  let descShow = []

  if (!originalData) {
    return {
      calData,
      personData,
      tableData,
      accountsData,
      accountMap,
      termsData,
      productNameList
    }
  }
  const formatKey = ['duration', 'period', 'mode', 'rage']
  const personOrderList = originalData.personData.personOrderList
  const productGroupList = originalData.productGroupList
  // 产品集
  if (Array.isArray(productGroupList)) {
    productGroupList.forEach(prods => {
      const prodlist = prods.prodOrderList
      descShow = Array.from({ length: prodlist.length }, () => false)
      if (!Array.isArray(prodlist)) return
      // 产品
      prodlist.forEach((prod, pidx) => {
        const pid = prod.key
        const com = prod.common
        const insurs = prod.mulInsOrderList
        const desLen = Array.isArray(insurs) ? insurs.length : 0
        descShow[pidx] = Array.from({ length: desLen }, () => false)
        productNameList[pid] = prod.titleName
        productCommonData[pid] = com
        // 险种
        insurs.forEach((ins, idx) => {
          const { key, code, name, fullName, accountData } = ins
          const bNormalize =
            Array.isArray(normalizeKeys) && normalizeKeys.length
          if (!bNormalize) {
            console.warn('normalizeKeys empty')
          }
          // 对字符串字段取值
          bNormalize &&
            normalizeKeys.forEach(item => {
              const _name = item.split('.')
              const _key = _name[0]
              const _trans = _name[1]
              if (!ins[_key]) return
              let value = '' + ins[_key]
              value = value.match(/\d+/) && value.match(/\d+/)[0]
              if (formatKey.indexOf(_trans) > -1) {
                value = value >= 1000 ? 1 : value
              }
              value = parseFloat(value)
              // 非数值置0
              ins[_trans] = isNaN(value) ? 0 : value
            })

          // 追加领取
          if (accountData) {
            accountsData.push({
              name,
              key,
              accountData
            })
            if (accountMap[pid]) {
              accountMap[pid][key] = accountData
            } else {
              accountMap[pid] = {
                [key]: accountData
              }
            }
          }
          pidx === 0 && idx === 0 && (personData['main'] = ins)
          // 险种名 i
          let insKey = `i${key}`
          // 产品名 p
          let prodKey = `p${pid}`
          if (calData[insKey]) {
            // 豁免险种
            // 根据豁免 value [beiHuomian touHuomian  shuanghuomian shm_spouse]
            if (ins.huomian) {
              !calData[insKey][prodKey] && (calData[insKey][prodKey] = {})
              calData[insKey][prodKey] = ins
            } else {
              calData[insKey][prodKey] = Object.assign({}, ins, com)
            }
          } else {
            calData[insKey] = {
              [prodKey]: Object.assign({}, ins, com)
            }
          }

          // 条款
          termsData.push({
            key,
            code,
            name,
            fullName
          })
          ins.productKey = prod.key
          tableData.push(ins)
        })
      })
    })
    personData['len'] = productGroupList[0].prodOrderList.length

    if (Array.isArray(personOrderList)) {
      personOrderList.forEach((person, index) => {
        const pid = person.key
        calData[pid] = person
        personData[pid] = person
      })
    }
    const recipient = originalData.personData.recipientInfo
    recipient &&
      Object.assign(personData, {
        [recipient.key]: recipient
      })

    return {
      descShow,
      calData,
      personData,
      tableData,
      accountsData,
      accountMap,
      termsData,
      productNameList,
      productCommonData
    }
  }
}

const ZJLQ_TYPE = '万能账户'
const ZJLQ_CODE_TYPE = 7 // 万能账户
/**
 * 格式化责任数据
 * @param {Object} originalData // 责任
 * @param {Array} insTypeOrder  // 险种类别排序
 * @param {Array} insTypeName   // 险种类别名称
 * @param {Object} accountMap   // 追加领取
 * @return {Object}
 */
export const formatLiabilitiesData = (
  originalData,
  insTypeOrder,
  insTypeName,
  accountMap
) => {
  let insList = []
  let instypeList = []
  let accInsList = []
  let diseasesPath = []
  const _originalData = originalData || []
  for (let pidx = 0, plen = _originalData.length; pidx < plen; pidx++) {
    let product = _originalData[pidx] // 产品
    let productId = product.productId
    let insurance = product.insuranceLiabilities
    let insuranceLen = insurance && insurance.length
    let arrangeProduct = []
    let accProduct = []
    let accInsurance = product.accidentLiabilities
    let accInsuranceLen = accInsurance && accInsurance.length

    if (!insuranceLen && !accInsuranceLen) continue
    for (let idx = 0; idx < insuranceLen; idx++) {
      let ins = insurance[idx] // 险种
      let insId = ins.insuranceId // 险种id
      let insName = ins.insuranceName // 险种名字
      let liabilities = ins.liabilities // 责任
      let liabilitiesLen = liabilities && liabilities.length

      let disease // 险种-所有责任的病重
      let instypeDisease = {}
      let insDisease = []
      for (let lidx = 0; lidx < liabilitiesLen; lidx++) {
        let liab = liabilities[lidx] // 责任
        let liabType = liab.categoryId // 责任类别
        let liabTypeName = liab.categoryName || insTypeName[liabType - 1] // 责任类别名
        let liabOrder = insTypeOrder.indexOf(liabType) // 责任排序

        if (liabOrder < 0) continue
        // 病种
        if (liab.disease && liab.disease.title) {
          disease = {
            pidx, // 产品index
            idx, // 险种
            lidx // 责任
          }

          if (Array.isArray(instypeDisease[liabOrder])) {
            instypeDisease[liabOrder].push(disease)
          } else {
            instypeDisease[liabOrder] = [disease]
          }

          if (Array.isArray(insDisease[pidx])) {
            insDisease[pidx].push(disease)
          } else {
            insDisease[pidx] = [disease]
          }
          // 病种集合
          diseasesPath.push(disease)
        }

        // 同责任类型的
        if (Array.isArray(instypeList[liabOrder])) {
          let matchingInsType = instypeList[liabOrder]
          let matchLen = matchingInsType.length - 1 || 0
          let exItem = matchingInsType[matchLen]

          let itDisease = instypeDisease[liabOrder]

          if (
            exItem.insuranceId === insId &&
            exItem.productId === productId &&
            exItem.liabilities &&
            exItem.liabilities.length
          ) {
            // 全部病种路径存储在第一条责任
            // disease && exItem.disease.push(disease)
            exItem.liabilities.push(liab)
            // 前责任无病种，后有病种需赋值
            if (!exItem.disease && disease) {
              exItem.disease = disease
              exItem.itDisease = itDisease
            }
          } else {
            instypeList[liabOrder].push({
              productId,
              insuranceId: insId,
              insuranceName: insName,
              liabilities: [liab],
              disease, // : [disease]
              itDisease,
              liabTypeName,
              ignore: !accInsuranceLen // 忽略类型
            })
          }
        } else {
          instypeList[liabOrder] = [
            {
              productId,
              insuranceId: insId,
              insuranceName: insName,
              liabilities: [liab],
              disease, // : [disease]
              itDisease: instypeDisease[liabOrder],
              liabTypeName,
              ignore: !accInsuranceLen // 忽略类型
            }
          ]
        }
      }

      let arrangeMap = {
        productId,
        disease,
        insDisease,
        ins
      }

      if (accountMap[productId] && accountMap[productId][insId]) {
        let liabType = ZJLQ_CODE_TYPE
        let liabOrder = insTypeOrder.indexOf(liabType)

        let insAccountMap = accountMap[productId][insId]

        let accountIndex = getAccountLiabIndex(instypeList[liabOrder], {
          productId,
          insId
        })

        // [万能账户]已存在，且追加领取
        // 1. 责任-追加领取
        if (accountIndex > -1) {
          instypeList[liabOrder][accountIndex].accountMap = insAccountMap
        } else {
          let arrangeTypeMap = {
            productId,
            insuranceId: insId,
            insuranceName: insName,
            // liabilities: [liab],
            liabTypeName: ZJLQ_TYPE,
            accountMap: insAccountMap
          }
          if (Array.isArray(instypeList[liabOrder])) {
            instypeList[liabOrder].push(arrangeTypeMap)
          } else {
            instypeList[liabOrder] = [arrangeTypeMap]
          }
        }
        // 2. 险种-追加领取
        arrangeMap.accountMap = insAccountMap
      }
      arrangeProduct.push(arrangeMap)
    }

    if (accInsuranceLen) {
      for (let accIndex = 0; accIndex < accInsuranceLen; accIndex++) {
        let ins = accInsurance[accIndex] // 险种

        let accMap = {
          productId,
          // disease,
          ins
        }
        accProduct.push(accMap)
      }
    }
    insList.push(arrangeProduct)
    accProduct.length && accInsList.push(accProduct)
  }

  return {
    diseasesPath,
    insList,
    instypeList,
    accInsList
  }
}

/**
 * 格式化长字符
 * @param {String} str [字符串]
 * @param {Number} len [显示长度]
 */
export const formatLongStr = (str, len) => {
  if (!str) return str
  const strAry = str.split('')
  const strLen = strAry.length
  const maxLen = len || 3
  return strLen > maxLen ? `${strAry.slice(0, maxLen).join('')}...` : str
}

/**
 * 格式化显示性别
 * @param {Number} index
 */
export const formatSexStr = index => {
  return index === 2 ? '女' : '男'
}

/**
 * 格式化保额显示
 *  - 计划
 * @param {Object} insurance
 */
export const formatBaoe = insurance => {
  const { baoe, baoeDesc, showPlanDesc, planDesc, plan } = insurance
  let baoeStr = baoeDesc || baoe
  if (showPlanDesc) {
    baoeStr = planDesc
  } else {
    baoeStr = formatTenThousand(baoeStr)
    // planDesc 存在且不等于 plan 显示
    // eslint-disable-next-line eqeqeq
    if (planDesc && planDesc != plan) {
      baoeStr = planDesc
    }
  }
  return baoeStr || '-'
}

/**
 * 格式化数字为中文
 * @param {Number} value
 */
export const formatNumToChinese = value => {
  if (isNaN(value)) return value
  return (
    ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'][value] || value
  )
}

const sliceStringToGroupsDefaultOption = {
  minChars: 3,
  maxLines: 3
}

function splitByConstantLen (str, charsPerLine) {
  const groups = []
  const strLen = str.length

  for (let start = 0; start < strLen; start += charsPerLine) {
    groups.push(str.slice(start, start + charsPerLine))
  }
  return groups
}

export function sliceStringToGroups (
  str,
  options,
) {
  if (typeof str !== 'string') {
    return { groups, charsPerLine: 0, maxLineWidth: 0 }
  }
  const strLen = str.length
  let charsPerLine
  let groups
  if ('bySpaces' in options && options.bySpaces) {
    groups = str.split(/\s+/)
    charsPerLine = Math.max(...groups.map(line => line.length))
  } else if ('maxChars' in options) {
    charsPerLine = Math.min(options.maxChars, strLen)
    groups = splitByConstantLen(str, charsPerLine)
  } else {
    const { maxLines, minChars } =
      'maxLines' in options ? options : sliceStringToGroupsDefaultOption
    const charsByGreedyLines = Math.ceil(strLen / maxLines)
    charsPerLine = Math.min(Math.max(charsByGreedyLines, minChars), strLen)
    groups = splitByConstantLen(str, charsPerLine)
  }

  return { groups, charsPerLine }
}
